/**
 * Поиск услуги или врача
 *
 * @param {Object} params
 * @param {String} params.fieldSearchServiceDoctor - поле поиска услуги или врача
 * @param {String} params.fieldSearchServiceDoctorResults - поле результатов поиска
 * @param {String} params.searchServiceDoctorResult - результат поиска
 * @param {String} params.templateResults - html шаблон результатов поиска
 * @param {String} params.urlApi - url обращения к api
 */
$.fn.searchServiceDoctor = function (params) {

    const $self = $(this);
    const $fieldSearchServiceDoctor = $self.find(params.fieldSearchServiceDoctor);
    const $fieldSearchServiceDoctorResults = $self.find(params.fieldSearchServiceDoctorResults);
    const searchServiceDoctorResult = params.searchServiceDoctorResult;
    const templateResults = $self.attr(params.templateResults);
    const urlApi = $self.attr(params.urlApi);

    /**
     * Поиск услуги или врача
     */

    $fieldSearchServiceDoctor.on('paste keyup change', function () {

        let title = $(this).val();

        if (title && title.length > 2) {
            update(title);
        } else {
            $fieldSearchServiceDoctorResults.html('');
        }

    });

    /**
     * Обновление результатов поиска
     *
     * @param title
     */
    const update = function (title) {

        $.ajax({
            method: 'GET',
            url: urlApi,
            data: {
                title: title
            }
        }).done(function (res) {

            let results = '';

            if (res.found.length > 0) {

                res.found.forEach(function (el) {

                    let pageName = '';

                    if (el.title) {
                        pageName = el.title;
                    } else {
                        pageName = el.surname + ' ' + el.name + ' ' + el.patronymic
                    }

                    results = templateResults;
                    $fieldSearchServiceDoctorResults.html(results);
                    $self.find($(searchServiceDoctorResult)).attr('href', el.urlPage);
                    $self.find($(searchServiceDoctorResult)).text(pageName);

                });

            } else {

                $fieldSearchServiceDoctorResults.html(results);
            }

        }).fail(function (error) {
            console.log(error);
        });
    };

    return this;
};

// инициализация
const init = function () {
    $('[data-search-service-doctor-module="true"]').searchServiceDoctor({
        urlApi: 'data-url-api',
        fieldSearchServiceDoctor: $('[data-search-service-doctor="true"]'),
        fieldSearchServiceDoctorResults: $('[data-search-service-results="true"]'),
        searchServiceDoctorResult: '[data-search-service-doctor-result="true"]',
        templateResults: 'data-template-results',
    });
};

if ($('[data-search-service-doctor-module="true"]').length > 0) {
    init();
}


